import { contieneRicerca, ugualeRicerca } from './ricerca';

/** Codici OEM di un prodotto: un elenco senza gerarchia, nessuno è il
 * principale (vedi **Codice OEM** in `CONTEXT.md`). Quando la ricerca ha
 * colpito un codice, quello va in testa all'elenco; il resto mantiene
 * l'ordine del gestionale. Il confronto è lo stesso del backend
 * (`utils/ricerca.ts`): sottostringa, senza maiuscole e ignorando i simboli.
 * A parità, il codice uguale al testo cercato precede quelli che lo
 * contengono soltanto. */
export function oemCodesCercatoPrima(codes?: string[] | null, cercato?: string | null): string[] {
  const list = (codes || []).filter(Boolean);
  if (!(cercato || '').trim()) return list;
  const rank = (code: string) => {
    if (ugualeRicerca(code, cercato)) return 0;
    return contieneRicerca(code, cercato) ? 1 : 2;
  };
  // Array.prototype.sort è stabile: a parità di rank resta l'ordine originale.
  return [...list].sort((a, b) => rank(a) - rank(b));
}

/** Il Codice OEM da mostrare in una riga: il codice cercato se la ricerca ne
 * ha colpito uno (`matchedOemCode` dal dropdown, oppure il codice che
 * contiene il testo cercato), altrimenti l'elenco completo. Stringa vuota se
 * il prodotto non ha codici OEM. */
export function codiceOemDaMostrare(
  p: { oemCodes?: string[] | null; matchedOemCode?: string | null },
  cercato?: string | null,
): string {
  if (p.matchedOemCode) return p.matchedOemCode;
  const ordered = oemCodesCercatoPrima(p.oemCodes, cercato);
  if (ordered.length > 0 && contieneRicerca(ordered[0], cercato)) return ordered[0];
  return ordered.join(', ');
}
